import columns from '../../../react-table/helpers/columns';

export default (data) => {
  const {
    TextColumn,
    NonZeroNumberColumn,
  } = columns(data);

  return [
    {
      Header: '',
      columns: [
        new TextColumn('', 'name'),
      ],
    },
    {
      Header: 'Quantity',
      columns: [
        new NonZeroNumberColumn('Preadvised', 'quantityPreAdvised'),
        new NonZeroNumberColumn('Confirmed', 'quantityConfirmed'),
        new NonZeroNumberColumn('Objected', 'quantityObjected'),
      ],
    },
  ];
};
